import { useMemo } from 'react';
import styles from '../../../../styles/automation/index.module.scss';
import { FileDropdownItem, VariableDropdownItem } from './SmartInputDropdownItems';

export default function SmartInputToolbar({
    dropdownMode,
    suggestions,
    fileSuggestions,
    activeIndex,
    descriptions,
    fileDescriptions,
    dropdownListRef,
    insertToken,
    setSelectedIndex,
}) {
    const dropdownListContent = useMemo(
        () => (
            <ul ref={dropdownListRef} className={styles.suggestionsList} tabIndex={0}>
                {dropdownMode === 'files'
                    ? fileSuggestions.map((item, index) => (
                          <FileDropdownItem
                              key={item.id}
                              item={item}
                              index={index}
                              activeIndex={activeIndex}
                              onSelect={insertToken}
                              onMouseEnter={setSelectedIndex}
                          />
                      ))
                    : suggestions.map((item, index) => (
                          <VariableDropdownItem
                              key={item.id}
                              item={item}
                              index={index}
                              activeIndex={activeIndex}
                              descriptions={descriptions}
                              onSelect={insertToken}
                              onMouseEnter={setSelectedIndex}
                          />
                      ))}
            </ul>
        ),
        [
            dropdownMode,
            suggestions,
            fileSuggestions,
            activeIndex,
            descriptions,
            insertToken,
            setSelectedIndex,
            dropdownListRef,
        ]
    );

    const dropdownDescriptionContent = useMemo(() => {
        if (dropdownMode === 'files') {
            const file = fileSuggestions[activeIndex];
            const desc = file ? fileDescriptions[file.id] : null;
            return (
                <div className={styles.variableDescription}>
                    <div className={styles.descriptionItem}>
                        <strong>File type</strong>
                        <div>{desc?.fileType ?? '—'}</div>
                    </div>
                    <div className={styles.descriptionItem}>
                        <strong>Description</strong>
                        <div>{desc?.description ?? '—'}</div>
                    </div>
                    <div className={styles.descriptionItem}>
                        <strong>Size</strong>
                        <div>{desc?.size ?? '—'}</div>
                    </div>
                    <div className={styles.descriptionItem}>
                        <strong>Folder</strong>
                        <div>{desc?.folder ?? '—'}</div>
                    </div>
                </div>
            );
        }
        return (
            <div className={styles.variableDescription}>
                <div className={styles.descriptionItem}>
                    <strong>KEY</strong>
                    <div>{descriptions[suggestions[activeIndex]?.id]?.key || '—'}</div>
                </div>
                <div className={styles.descriptionItem}>
                    <strong>Type</strong>
                    <div>
                        {descriptions[suggestions[activeIndex]?.id]?.systemVariable
                            ? 'Project Variable'
                            : 'Environment Variable'}
                    </div>
                </div>
                <div className={styles.descriptionItem}>
                    <strong>Encrypted</strong>
                    <div>{descriptions[suggestions[activeIndex]?.id]?.isSecret ? 'Yes' : 'No'}</div>
                </div>
            </div>
        );
    }, [dropdownMode, suggestions, fileSuggestions, activeIndex, descriptions, fileDescriptions]);

    return (
        <>
            {dropdownListContent}
            {dropdownDescriptionContent}
        </>
    );
}
